import {useState, useEffect} from "react";

const InputValue = ({value, state, setValue, }) => {
  const [initData, setInitData] = useState(value);

  useEffect(() => {
    setInitData(value);
  }, [value]);

  const handleLeadValueChange = (event) => {
    const newValue = event.target.value;
    // Allow numeric values with optional decimals (e.g., 123, 123.45, .45)
    if (/^\d*\.?\d*$/.test(newValue)) {
        setInitData(newValue);
        setValue({...state, lead_value: newValue})
    }
  };
  return (
    <div>
      <input
        type="text"
        inputMode="numeric"
        value={initData}
        onChange={handleLeadValueChange}
        className="form-control form-control-sm"
      />
    </div>
  );
};

export default InputValue;
